import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import AddOrEditVendor from "./AddOrEditVendor";
import Adminaccountsone from "./Adminaccountsone";
import AdminCharities from "./AdminCharities";
import AdminCharityPayouts from "./AdminCharityPayouts";
import Adminfaqone from "./Adminfaqone";
import Adminfeaturedvendorsone from "./Adminfeaturedvendorsone";
import AdminForgotpassword from "./AdminForgotpassword";
import Adminindustrysectorsone from "./Adminindustrysectorsone";
import Adminmembersone from "./Adminmembersone";
import Adminmemberstwo from "./Adminmemberstwo";
import AdminNewPassword from "./AdminNewPassword";
import AdminOTPAuthentication from "./AdminOtpAuth";
import Adminpayments from "./Adminpayments";
import AdminPayoutRequests from "./AdminPayoutRequests";
import Adminprofilesettings from "./Adminprofilesettings";
import Adminprofileupdaterequests from "./Adminprofileupdaterequests";
import Adminqueriesone from "./Adminqueriesone";
import Adminrecommendationsone from "./Adminrecommendationsone";
import Adminrecommendationstwo from "./Adminrecommendationstwo";
import Adminreferralsfive from "./Adminreferralsfive";
import Adminreferralsone from "./Adminreferralsone";
import Adminreferralsthree from "./Adminreferralsthree";
import AdminReferredFriends from "./AdminReferredFriends";
import AdminReferReward from "./AdminReferReward";
import AdminVendorProfile from "./AdminVendorProfile";
import Adminvendorshomeone from "./Adminvendorshomeone";
import Adminvendorsone from "./Adminvendorsone";
import Adminvendorstwo from "./Adminvendorstwo";
import Adminwaitlist from "./Adminwaitlist";
import Home from "./Home";
import Image2 from "./Image2";
import Image3 from "./Image3";
import Image4 from "./Image4";
import ModalAdminaccountsone from "./ModalAdminaccountsone";
import ModalAdminfaqone from "./ModalAdminfaqone";
import ModalAdminfeaturedvendorsone from "./ModalAdminfeaturedvendorsone";
import ModalAdminindustrysectorsone from "./ModalAdminindustrysectorsone";
import ModalAdminmembersone from "./ModalAdminmembersone";
import ModalAdminmemberstwo from "./ModalAdminmemberstwo";
import ModalAdminpayments from "./ModalAdminpayments";
import ModalAdminreferralstwo from "./ModalAdminreferralstwo";
import ModalAdmintrustedvendorshomeone from "./ModalAdmintrustedvendorshomeone";
import ModalAdminvendorsone from "./ModalAdminvendorsone";
import ProtectedRoute from "./ProtectedRoute";
import Update from "./Update";
import AdminPendingReferrals from "./AdminPendingreferrals";
import Adminreferralsfour from "./Adminreferralsfour";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "home",
    element: <Home />,
  },
  {
    path: "adminreferralsone",
    element: (
      <ProtectedRoute>
        <Adminreferralsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminpendingreferrals",
    element: (
      <ProtectedRoute>
        <AdminPendingReferrals />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminreferralsone/:id",
    element: (
      <ProtectedRoute>
        <Adminreferralsthree />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminpendingreferrals/:id",
    element: (
      <ProtectedRoute>
        <Adminreferralsfour />
      </ProtectedRoute>
    ),
  },

  {
    path: "modal-adminreferralstwo",
    element: (
      <ProtectedRoute>
        <ModalAdminreferralstwo />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminreferralsthree",
    element: (
      <ProtectedRoute>
        <Adminreferralsthree />
      </ProtectedRoute>
    ),
  },

  {
    path: "adminreferralsfive",
    element: (
      <ProtectedRoute>
        <Adminreferralsfive />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminwaitlist",
    element: (
      <ProtectedRoute>
        <Adminwaitlist />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminmembersone",
    element: (
      <ProtectedRoute>
        <Adminmembersone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminmembersone/:id",
    element: (
      <ProtectedRoute>
        <Adminmemberstwo />
      </ProtectedRoute>
    ),
  },
  {
    path: "modal-adminmembersone",
    element: (
      <ProtectedRoute>
        <ModalAdminmembersone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminmemberstwo",
    element: (
      <ProtectedRoute>
        <Adminmemberstwo />
      </ProtectedRoute>
    ),
  },
  {
    path: "update",
    element: (
      <ProtectedRoute>
        <Update />
      </ProtectedRoute>
    ),
  },
  {
    path: "modal-adminmemberstwo",
    element: (
      <ProtectedRoute>
        <ModalAdminmemberstwo />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminpayments",
    element: (
      <ProtectedRoute>
        <Adminpayments />
      </ProtectedRoute>
    ),
  },
  {
    path: "modal-adminpayments",
    element: (
      <ProtectedRoute>
        <ModalAdminpayments />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminqueriesone",
    element: (
      <ProtectedRoute>
        <Adminqueriesone />
      </ProtectedRoute>
    ),
  },

  {
    path: "adminvendorsone",
    element: (
      <ProtectedRoute>
        <Adminvendorsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminvendorsone/:id",
    element: (
      <ProtectedRoute>
        <Adminvendorstwo />
      </ProtectedRoute>
    ),
  },
  {
    path: "modal-adminvendorsone",
    element: (
      <ProtectedRoute>
        <ModalAdminvendorsone />
      </ProtectedRoute>
    ),
  },

  {
    path: "adminvendorstwo",
    element: (
      <ProtectedRoute>
        <Adminvendorstwo />
      </ProtectedRoute>
    ),
  },

  {
    path: "adminrecommendationsone",
    element: (
      <ProtectedRoute>
        <Adminrecommendationsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminrecommendationstwo",
    element: (
      <ProtectedRoute>
        <Adminrecommendationstwo />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminfeaturedvendorsone",
    element: (
      <ProtectedRoute>
        <Adminfeaturedvendorsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "modal-adminfeaturedvendorsone",
    element: (
      <ProtectedRoute>
        <ModalAdminfeaturedvendorsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminindustrysectorsone",
    element: (
      <ProtectedRoute>
        <Adminindustrysectorsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "modal-adminindustrysectorsone",
    element: (
      <ProtectedRoute>
        <ModalAdminindustrysectorsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminvendorshomeone",
    element: (
      <ProtectedRoute>
        <Adminvendorshomeone />
      </ProtectedRoute>
    ),
  },

  {
    path: "image",
    element: (
      <ProtectedRoute>
        <Image3 />
      </ProtectedRoute>
    ),
  },

  {
    path: "modal-admintrustedvendorshomeone",
    element: (
      <ProtectedRoute>
        <ModalAdmintrustedvendorshomeone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminfaqone",
    element: (
      <ProtectedRoute>
        <Adminfaqone />
      </ProtectedRoute>
    ),
  },
  {
    path: "modal-adminfaqone",
    element: (
      <ProtectedRoute>
        <ModalAdminfaqone />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminaccountsone",
    element: (
      <ProtectedRoute>
        <Adminaccountsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "modal-adminaccountsone",
    element: (
      <ProtectedRoute>
        <ModalAdminaccountsone />
      </ProtectedRoute>
    ),
  },
  {
    path: "image",
    element: (
      <ProtectedRoute>
        <Image2 />
      </ProtectedRoute>
    ),
  },
  {
    path: "image",
    element: (
      <ProtectedRoute>
        <Image4 />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminprofileupdaterequests",
    element: (
      <ProtectedRoute>
        <Adminprofileupdaterequests />
      </ProtectedRoute>
    ),
  },
  {
    path: "adminprofilesettings",
    element: (
      <ProtectedRoute>
        <Adminprofilesettings />
      </ProtectedRoute>
    ),
  },
  {
    path: "forgotpassword",
    element: <AdminForgotpassword />,
  },
  {
    path: "AdminVendorProfile",
    element: (
      <ProtectedRoute>
        <AdminVendorProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "AdminOTPAuthentication",
    element: <AdminOTPAuthentication />,
  },
  {
    path: "new-password",
    element: <AdminNewPassword />,
  },
  {
    path: "charities",
    element: <AdminCharities />,
  },
  {
    path: "payout-requests",
    element: <AdminPayoutRequests />,
  },
  {
    path: "charity-payouts",
    element: <AdminCharityPayouts />,
  },
  {
    path: "reffered-friends",
    element: <AdminReferredFriends />,
  },
  {
    path: "refer-reward",
    element: <AdminReferReward />,
  },
  {
    path: "add-vendor",
    element: <AddOrEditVendor />,
  },
]);

const App = () => {
  const isStaging = process.env.REACT_APP_ENV === "staging";
  return (
    <div>
      {isStaging && (
        <>
          <div
            style={{
              color: "red",
              padding: "10px",
              textAlign: "center",
              fontWeight: "bold",
              zIndex: 9999,
            }}
          >
            🔴 STAGING ENVIRONMENT
          </div>
        </>
      )}
      <RouterProvider router={router} />
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};
export default App;
